import React from 'react';
import PropTypes from 'prop-types';

const GDPRDeleteButton = ({ onClick, className, disabled }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    type="button"
    className={className}
  >
    <span className="c-btn__text">GDPR Delete</span>
  </button>
);

GDPRDeleteButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

GDPRDeleteButton.defaultProps = {
  className: 'c-btn c-btn--grey c-btn--small u-mt-',
  disabled: false,
};

export default GDPRDeleteButton;
